import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/mailsent.svg'


const _hoisted_1 = {
  key: 0,
  class: "modalbody"
}
const _hoisted_2 = {
  key: 0,
  class: "labeldiv"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "font-regular-14 breaking-words mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "CSV File Instructions:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("ul", { style: {"margin":"0 0 0 1.2em","padding":"0"} }, [
    /*#__PURE__*/_createElementVNode("li", null, "Separate values using comma , or semicolon ;"),
    /*#__PURE__*/_createElementVNode("li", null, "Include a header row: FirstName,LastName,Email")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"0.5em"} }, [
    /*#__PURE__*/_createElementVNode("b", null, "Example:")
  ]),
  /*#__PURE__*/_createElementVNode("pre", { class: "csvexample" }, "          FirstName,LastName,Email\n          John,Doe,john.doe@domain.com\n          Mike,Smith,mike.smith@domain.com\n        ")
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "error-label font-bold-16" }, " Please verify the below errors in the CSV file:", -1)
const _hoisted_6 = { class: "validationErrors" }
const _hoisted_7 = { class: "datadisplaydiv" }
const _hoisted_8 = { class: "buttonsdiv" }
const _hoisted_9 = {
  key: 1,
  class: "modalbody"
}
const _hoisted_10 = { class: "labeldiv" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold-18 btm-2" }, "Preview users from CSV file ", -1)
const _hoisted_12 = { class: "font-regular-18 mb-3" }
const _hoisted_13 = { class: "userlistdiv" }
const _hoisted_14 = { class: "font-regular-16 breaking-words" }
const _hoisted_15 = { class: "buttonsdiv" }
const _hoisted_16 = {
  key: 2,
  class: "modalbody"
}
const _hoisted_17 = {
  key: 0,
  class: "innerModal"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"70px","margin-bottom":"1rem"},
  alt: "mailsentimg",
  title: "mailsentimg"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "labelbld" }, "Your file is currently being processed. You will receive an email notification once it’s complete. After that, please refresh the user list to see new users. ", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "buttonsdiv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_document = _resolveComponent("document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.taskType === 'browsecsv')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.taskType === 'browsecsv')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createVNode(_component_el_upload, {
                  ref: "uploadRef",
                  "before-upload": _ctx.beforeUpload,
                  "show-file-list": false,
                  accept: ".csv",
                  limit: 1,
                  class: "w-full mb-3"
                }, {
                  trigger: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      round: "",
                      class: "csvbuttonstyle",
                      variant: "warning",
                      id: "uploadcsvfile"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Upload CSV file")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["before-upload"]),
                _createVNode(_component_el_input, {
                  modelValue: _ctx.choosedFilepath,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.choosedFilepath) = $event)),
                  placeholder: "No file selected",
                  readonly: "",
                  class: "user-inputstyle"
                }, {
                  prefix: _withCtx(() => [
                    _createVNode(_component_el_icon, { size: 25 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_document)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.showCSVErrors)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.csvErrors, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "font-regular-16 btm-1"
                          }, [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(item), 1)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              id: "adduserbutton",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.nextCSVFileHandler,
              disabled: _ctx.selectedCSVFile === undefined || _ctx.showCSVErrors
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Next ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_button, {
              id: "addcompanyuserbutton",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.goBacktoAddSingleUser
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Back ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              id: "usercancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "cancelbtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.taskType === 'previewcsv')
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("label", _hoisted_12, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.csvRowsCount), 1),
              _createTextVNode(" users will be added and below is the preview of first 10 users for your reference ")
            ]),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewUsers, (user, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(user.firstname) + ", " + _toDisplayString(user.lastname) + ", " + _toDisplayString(user.email), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_button, {
              id: "adduserbutton",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.uploadCSVFileUsers
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Send Invite ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              id: "addcompanyuserbutton",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.browseCSVFileHandler
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Back ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              id: "usercancel",
              round: "",
              variant: "outline-dark",
              onClick: _ctx.cancelInvite,
              class: "cancelbtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true),
    (_ctx.taskType === 'csvResponseReceived')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          (_ctx.csvResponseReceived)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_button, {
              id: "adduserdone",
              round: "",
              class: "btnstyle",
              variant: "warning",
              onClick: _ctx.cancelInvite,
              style: {"float":"right"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Done ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}